import { render, staticRenderFns } from "./ThongBaoList.vue?vue&type=template&id=1c725ed4&scoped=true&"
import script from "./ThongBaoList.vue?vue&type=script&lang=js&"
export * from "./ThongBaoList.vue?vue&type=script&lang=js&"
import style0 from "./ThongBaoList.vue?vue&type=style&index=0&id=1c725ed4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c725ed4",
  null
  
)

export default component.exports